import { appState } from './state.app'

const initialMenuState = {
    persist: {
        mute: true,
    },
}

const setMenuState = appState('MENU', initialMenuState)

export const getMenuState = () => appState().MENU

const defaultMenuState = {
    persist: {
        mute: true,
    },
    // isOpen: false,
    id: null,
}

// export const setMenuOpenState = (isOpen: boolean) => {
//     setMenuState({ modifications: { isOpen } })
// }

export const setMenuIDState = (id: number) => {
    setMenuState({ modifications: { id } })
}

export const setMenuMuteState = (mute: boolean) => {
    setMenuState({
        modifications: {
            persist: {
                mute,
            },
        },
    })
}

export const resetMenuState = () => {
    const { persist } = getMenuState()
    setMenuState({ modifications: { ...defaultMenuState, persist } })
}
